{
  "slug": "iq-score-confidence-intervals",
  "title": "IQ Score Confidence Intervals Explained",
  "description": "Understand why IQ reports include confidence intervals and why a score range is often more informative than one number.",
  "summary": "Every IQ score contains measurement uncertainty. A confidence interval communicates a plausible range around the reported estimate under the test’s statistical model.",
  "category": "Science of testing",
  "sections": [
    {
      "heading": "Why one number is not exact",
      "paragraphs": [
        "Performance varies with item sampling, day-to-day conditions, and ordinary measurement error. A reported composite therefore estimates a standing rather than revealing a perfectly fixed quantity.",
        "Professional score reports commonly pair the point estimate with a confidence interval derived from a standard error of measurement or estimation."
      ]
    },
    {
      "heading": "How to read the interval",
      "paragraphs": [
        "If a report gives a score of 104 with a 95 percent interval of 99–109, the interval should be considered when comparing the result with a cutoff or another score. It is not a prediction that 95 percent of future scores must fall there.",
        "Wider intervals indicate less precision. Different composites can have different standard errors even within the same assessment."
      ]
    },
    {
      "heading": "Decisions near thresholds",
      "paragraphs": [
        "Small differences should not be overinterpreted, especially when confidence intervals overlap. A rigid decision based on a single point can imply more precision than the test supports.",
        "Qualified interpretation also considers subtest patterns, referral question, history, behavior, language, and the consequences of error."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Does the confidence interval mean my IQ changes within that range?",
      "answer": "It mainly expresses uncertainty in the estimate; real performance can also vary across occasions and conditions."
    },
    {
      "question": "Why do online tests often show no interval?",
      "answer": "Some provide simplified feedback or lack enough published evidence to estimate precision responsibly."
    }
  ],
  "related": [
    "raw-scores-vs-scaled-iq-scores",
    "iq-test-reliability",
    "how-is-iq-measured",
    "ceiling-and-floor-effects-in-iq-testing"
  ],
  "sources": [
    {
      "label": "Pearson — WAIS-5 sample score report",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report-with-demographically-referenced-scores.pdf"
    },
    {
      "label": "Standards for Educational and Psychological Testing",
      "url": "https://www.testingstandards.net/"
    }
  ]
}
